import { Typography, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import React, { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

import { ShowMoreButton } from '@/shared/ui/ShowMoreButton'
import Channel from '@/shared/classes/channels/channel'
import { ChannelView } from './ChannelView'

interface IChannelsSearchResults {
    channelsSet: Channel[]
    showMore: boolean
    setShowMore: Dispatch<SetStateAction<boolean>>
    onItemClick?: () => void
}

export const ChannelsSearchResults = ({
    channelsSet,
    showMore,
    setShowMore,
    onItemClick,
}: IChannelsSearchResults) => {
    const { t: translate } = useTranslation()
    const theme = useTheme()

    const shortenChannelsSet =
        !showMore && channelsSet.length > 3
            ? channelsSet.slice(0, 3)
            : channelsSet

    const noResultsInfoStyle = {
        marginTop: '50px',
        textAlign: 'center',
        width: '100vw',
        maxWidth: { xs: 'unset', lg: '440px' },
    }

    const channelsListStyle = {
        marginTop: '17px',
        width: { xs: 'calc(100% - 16px)', lg: '100%' },
        margin: 'auto',
        maxWidth: '100%',
        position: 'relative',
        overflow: 'auto',
        overflowX: 'hidden',
        padding: 0,
        '& ul': { padding: 0 },
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
        columnCount: showMore ? 2 : 'unset',
        columnGap: '20px',
    }
    const listItem = {
        padding: '0',
        justifyContent: 'center',
        breakInside: 'avoid',
        maxWidth: showMore ? '380px' : 'unset',
        minHeight: showMore ? '80px' : 'unset',
        display: 'block',
    }
    const channelsToDisplay = shortenChannelsSet.map((channel: Channel) => (
        <ListItem key={channel.id} sx={listItem}>
            <ChannelView
                key={channel.id}
                channel={channel}
                onPopperClose={onItemClick}
            />
        </ListItem>
    ))
    return (
        <Box onClick={onItemClick}>
            <Typography
                color="white"
                variant="subtitle1"
                pb="16px"
                borderBottom={`1px solid ${theme.palette.custom.border}`}>
                {translate('channels')}: {channelsSet.length}
            </Typography>
            {channelsToDisplay.length ? (
                <>
                    <List sx={channelsListStyle}>{channelsToDisplay}</List>
                    <ShowMoreButton
                        setShowMore={setShowMore}
                        showMore={showMore}
                    />
                </>
            ) : (
                <Typography sx={noResultsInfoStyle} variant="subtitle2">
                    {channelsSet.length
                        ? translate('lackOfSearchResults')
                        : 'no channels'}
                </Typography>
            )}
        </Box>
    )
}
